import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Form, Input, Message} from 'semantic-ui-react';
import DatePicker from 'app-ui-componentlibrary/dist/go/components/common/singleDatePickerWrapper';
import withChangeHandler from './withChangeHandler';
import {isParseableDate, occursAfter} from 'go/components/rules/rules';
import {cutDateTimeOff} from 'common/utils';

const MANAGED_PROPS = ['id', 'questionLabel', 'questionText', 'style', 'value'];

export const DateWithChangeHandler = withChangeHandler(Input);

const isParseableDateFunc = isParseableDate();

export default class extends React.Component {
  static propTypes = {
    /** A unique id */
    id: PropTypes.string,

    /** The label for the question */
    questionLabel: PropTypes.string,

    /** The text for the question */
    questionText: PropTypes.string.isRequired,

    /** The unique key of the property within the form backing model */
    modelKey: PropTypes.string.isRequired,

    /** The current value of the field */
    value: PropTypes.any,
  };

  todayOrAfterRule = occursAfter(this.props.title);

  validateDate = () => {
    let returnValue = {
      status: true,
      dateErrors: [],
    };

    let isParseable = isParseableDateFunc(this.props.value);
    if (!isParseable) {
      returnValue.dateErrors.push('Date must be in YYYY-MM-DD format');
      returnValue.status = false;
    }

    if (this.props.rules) {
      if (this.props.rules.includes('todayOrAfter')) {
        const now = cutDateTimeOff(new Date().toISOString());
        const today = {
          resubmissionDeadline: now,
        };
        let isAfterToday = this.todayOrAfterRule(this.props.value, today);
        if (!isAfterToday) {
          returnValue.dateErrors.push('Date must be after current date');
          returnValue.status = false;
        }
      }
    }

    return returnValue;
  };

  constructor(props) {
    super(props);

    this.id = props.id;
    this.questionLabel = props.questionLabel;
    this.questionText = props.questionText;
    this.modelKey = props.modelKey;
    this.rules = props.rules;
    this.state = {
      error: false,
    };
  }

  render = () => {
    const filteredProps = _.omit(this.props, MANAGED_PROPS);
    const dateStatus = this.validateDate();
    return (
      <React.Fragment>
        <Form.Field key={this.id} error={!dateStatus.status}>
          {this.questionText && <div className="questionText">{this.questionText}</div>}
          <label htmlFor={this.id}>{this.questionLabel}</label>
          {!dateStatus.status &&
            dateStatus.dateErrors.map((error) => {
              return <Message negative>{error}</Message>;
            })}
          <div className="ui form" style={this.props.style}>
            <DateWithChangeHandler
              id={this.id}
              onBlur={() => {
                this.validateDate();
              }}
              type="date"
              value={this.props.value}
              {...filteredProps}
            />
          </div>
        </Form.Field>
      </React.Fragment>
    );
  };
}
